import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { NotificationsDialogComponent } from '../notifications-dialog/notifications-dialog.component';
import { NavigationService } from '@app/core/services/navigation/navigation.service';
import { SignalrService } from '@app/core/services/signalr/signalr.service';
import { HeaderButton, HeaderControlService } from '@app/shared/services/header.control.service';
import { take } from 'rxjs';

const DIALOG_PADDING_BOTTOM = 360;

@Component({
    selector: 'cb-topnav-title',
    templateUrl: './topnav-title.component.html',
    styleUrls: ['./topnav-title.component.scss'],
    standalone: false
})
export class TopnavTitleComponent implements OnInit {

    @Input() public sidenav: MatSidenav;
    public notificationsOpen = false;
    public buttons: HeaderButton[] = [];
    public get unreadNotificationsCount(): number {
        return (this.signalRService.unreadNotifications || []).length;
    }

    private dialogRef: MatDialogRef<NotificationsDialogComponent>;

    constructor(
        public readonly dialog: MatDialog,
        public readonly navigationService: NavigationService,
        private readonly signalRService: SignalrService,
        private headerControl: HeaderControlService
    ) { }

    public ngOnInit(): void {
        this.headerControl.currentButtons.subscribe(buttons => {
            this.buttons = buttons;
        });
    }

    public openNotifications(event: MouseEvent): void {
        if (this.notificationsOpen) {
            return this.dialogRef.close();
        }
        this.dialogRef = this.dialog.open(
            NotificationsDialogComponent,
            {
                width: '360px',
                height: `${window.innerHeight - DIALOG_PADDING_BOTTOM}px`,
                position: { top: '104px', right: '8px' },
                hasBackdrop: false,
                data: {
                    navigationService: this.navigationService,
                    notificationHubService: this.signalRService
                }
            }
        );
        this.dialogRef.afterOpened()
            .pipe(take(1)).subscribe(() => {
                this.notificationsOpen = true;
            });
        this.dialogRef.afterClosed()
            .pipe(take(1)).subscribe(() => {
                this.notificationsOpen = false;
            });
    }

    public goToHome(): void {
        this.navigationService.navigate(['/']);
    }
}
